import { ADD_ERROR, REMOVE_ERROR, REMOVE_ERROR_KEY, REMOVE_ERROR_TYPE } from './actions';
import { RtrError } from './types';

const initialState: RtrError[] = [];

export function errorsReducer(state = initialState, action: any): RtrError[] {
  switch (action.type) {
    case ADD_ERROR: {
      const newError: RtrError = action.payload;
      const indexOfExistingError = state.findIndex(err => {
        const compareMessages = err.message === newError.message;
        const compareTypes = err.type === newError.type || (!err.type && !newError.type);
        return compareMessages && compareTypes;
      });
      newError.errorKey = 'Err' + new Date().valueOf();
      if (indexOfExistingError < 0) {
        return [...state, newError];
      } else {
        const newState = [...state];
        newState.splice(indexOfExistingError, 1);
        return [...newState, newError];
      }
    }
    case REMOVE_ERROR: {
      const errorToRemove: RtrError = action.payload;
      const newState = state.filter(err => {
        const differentMessage = err.message !== errorToRemove.message;
        const differentType = err.type !== errorToRemove.type || (!err.type && !errorToRemove.type);
        return differentMessage && differentType;
      });
      return [...newState];
    }
    case REMOVE_ERROR_TYPE: {
      const newState = state.filter(err => err.type !== action.payload);
      return [...newState];
    }
    case REMOVE_ERROR_KEY: {
      const newState = state.filter(err => err.errorKey !== action.payload);
      return [...newState];
    }
    default:
      return state;
  }
}
